import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const useHealthlinkCalls = ({ page = 1, rows = 20, startDate = null, endDate = null, enabled = true }) => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const fetchHealthlinkCalls = async () => {
    const axiosInstance = createAxiosInstance();
    const params = new URLSearchParams({
      page: page.toString(),
      rows: rows.toString(),
    });

    if (startDate) {
      params.append('startDate', startDate);
    }
    if (endDate) {
      params.append('endDate', endDate);
    }

    const response = await axiosInstance.get(
      `${tenant}/healthlink/calls/daterange/paginated?${params.toString()}`
    );

    return response.data;
  };

  return useQuery({
    queryKey: ["healthlinkCalls", tenant, page, rows, startDate, endDate],
    queryFn: fetchHealthlinkCalls,
    enabled: enabled && !!tenant,
    staleTime: 5 * 60 * 1000,
  });
};

export { useHealthlinkCalls };